import {
  Box, Grid, Typography, Paper, TextField, InputAdornment, Autocomplete, Chip, useTheme, styled, Button, Tooltip, Avatar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  PriorityHigh as PriorityHighIcon,
  DoneAll as DoneAllIcon,
  Cancel as CancelIcon,
  Autorenew as AutorenewIcon,
  KeyboardBackspace as KeyboardBackspaceIcon,
  ListAlt as ListAltIcon,
  Equalizer as EqualizerIcon,
  Pause as PauseIcon
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { selectGlobalProperty } from "../../../../redux/propertySlice";
import axiosInstance from "../../../../lib/axios";
import TaskStDialog from "./TaskStDialog";
import TaskStatusTable from "./TaskStatusCards";
import MultiStUpDlog from "./MultiStUpDlog";
import FollowUpHistory from "./FollowUpHistory";

const StyledCard = styled(Paper)(({ theme }) => ({
  borderRadius: 20,
  transition: "transform 0.4s ease, box-shadow 0.4s ease",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: theme.shadows[10],
  },
  background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[100]} 100%)`,
  border: `1px solid ${theme.palette.divider}`,
  overflow: "hidden",
  padding: theme.spacing(0.5),
  paddingLeft: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    minHeight: "70px",
  },
}));

const StyledAvatar = styled("div")(({ theme, status }) => ({
  backgroundColor:
    status === "O"
      ? theme.palette.error.main
      : status === "I"
        ? theme.palette.warning.main
        : status === "H"
          ? "#9c27b0"
          : status === "R"
            ? "#FF5722"
            : status === "C"
              ? theme.palette.success.main
              : status === ""
                ? "#00ACC1"
                : theme.palette.primary.light,
  width: 32,
  height: 32,
  boxShadow: `0 2px 8px ${theme.palette.grey[400]}`,
  border: `2px solid ${theme.palette.background.paper}`,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.2rem",
  [theme.breakpoints.down("sm")]: {
    width: 28,
    height: 28,
    fontSize: "1rem",
  },
}));

const getStatusText = (status) => {
  switch (status) {
    case "O":
      return "Open";
    case "I":
      return "In Progress";
    case "H":
      return "Hold";
    case "R":
      return "Resolved";
    case "C":
      return "Closed";
    default:
      return "Unknown";
  }
};

export default function TaskStatus() {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState([]);
  const [warden, setWarden] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedWarden, setSelectedWarden] = useState(null);
  const [rows, setRows] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [selectedRowCategoryId, setSelectedRowCategoryId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [multiDialogOpen, setMultiDialogOpen] = useState(false);
  const [ticketCounts, setTicketCounts] = useState({
    open: 0,
    inprogress: 0,
    hold: 0,
    resolved: 0,
    closed: 0,
    totaltickets: 0,
  });

  const currentDate = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(currentDate.getMonth() - 1);
  const formatDateForInput = (date) => date.toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(formatDateForInput(oneMonthAgo));
  const [toDate, setToDate] = useState(formatDateForInput(currentDate));
  const UserId = sessionStorage.getItem("UserId");
  const assignBy = sessionStorage.getItem("UserName");
  const navigate = useNavigate();
  const globalProperty = useSelector(selectGlobalProperty);
  const [followHistory, setFollowHistory] = useState([]);
  const [historyTicketId, setHistoryTicketId] = useState(null);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);

  const handleOpenHistory = (ticketId) => {
    setHistoryTicketId(ticketId);
    setHistoryDialogOpen(true);
    fetchFollowHistory(ticketId);
  };

  const fetchCardData = async () => {
    if (!globalProperty || !selectedCategory?.Id || !selectedWarden?.Id) return;

    try {
      const response = await axiosInstance.post("TrnTicketing/GetFilterTicketDashBoard", {
        PageNumber: 1,
        PageSize: 10,
        PropId: globalProperty,
        Id: selectedCategory.Id,
        WardenId: selectedWarden.Id,
        ServiceProvId: 1,
        SearchText: "",
        SearchFrom: fromDate,
        SearchTo: toDate,
        Flag: "PropStatusCount",
      });

      const { data: { Status, Data }, } = response;

      if (Status === 0 && Array.isArray(Data)) {
        const counts = {
          open: 0,
          inprogress: 0,
          hold: 0,
          resolved: 0,
          closed: 0,
        };

        Data.forEach((item) => {
          switch (item.Status) {
            case "O":
              counts.open = item.TotalCount;
              break;
            case "I":
              counts.inprogress = item.TotalCount;
              break;
            case "H":
              counts.hold = item.TotalCount;
              break;
            case "R":
              counts.resolved = item.TotalCount;
              break;
            case "C":
              counts.closed = item.TotalCount;
              break;
            default:
              break;
          }
        });

        counts.totaltickets = counts.open + counts.inprogress + counts.resolved + counts.closed + counts.hold;
        setTicketCounts(counts);
      } else {
        setTicketCounts({
          open: 0,
          inprogress: 0,
          resolved: 0,
          closed: 0,
          hold: 0,
        });
      }
    } catch (error) {
      setTicketCounts({
        open: 0,
        inprogress: 0,
        resolved: 0,
        closed: 0,
        hold: 0,
      });
      toast.error("Error fetching ticket counts. Please try again.");
    }
  };

  useEffect(() => {
    const fetchWardenName = async () => {
      if (!globalProperty) return;

      try {
        const response = await axiosInstance.post(`/TrnTicketing/getPropertyWisedrp`, {
          PropId: globalProperty,
          Flag: "RaisedBy",
        });
        const { data: { Status, Data }, } = response;
        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          const allWarden = { Id: 1, Name: "All" };
          setWarden([allWarden, ...Data]);
          setSelectedWarden(allWarden);
        } else {
          setWarden([]);
          setSelectedWarden(null);
          toast.warn("No wardens available.", {
            autoClose: 1000,
          });
        }
      } catch (error) {
        setWarden([]);
        setSelectedWarden(null);
        toast.error("Error fetching wardenName. Please try again");
      }
    };

    fetchWardenName();
  }, [globalProperty]);

  useEffect(() => {
    const fetchCategoryName = async () => {
      if (!globalProperty) return;

      try {
        const response = await axiosInstance.post(
          `TrnTicketing/getPropertyWisedrp`,
          {
            PropId: globalProperty,
            flag: "Cat",
          }
        );
        const {
          data: { Status, Data },
        } = response;

        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          const allCategory = { Id: 1, Name: "All" };
          setCategories([allCategory, ...Data]);
          setSelectedCategory(allCategory);
        } else {
          setCategories([]);
          setSelectedCategory(null);
        }
      } catch (error) {
        setCategories([]);
        setSelectedCategory(null);
        toast.error("Error fetching categoryName. Please try again", {
          autoClose: 1000,
        });
      }
    };

    fetchCategoryName();
  }, [globalProperty]);

  useEffect(() => {
    if (globalProperty && selectedCategory?.Id && selectedWarden?.Id) {
      if (isInitialFetch) {
        setSelectedStatus("I");
        fetchTickets("I");
        setIsInitialFetch(false);
      }
      fetchCardData();
    }
  }, [globalProperty, selectedCategory, selectedWarden, fromDate, toDate]);

  const fetchTickets = async (overrideStatus = selectedStatus) => {
    try {
      if (!globalProperty || !selectedCategory?.Id) {
        toast.error("Property or category is not set.");
        return;
      }
      const response = await axiosInstance.post("TrnTicketing/GetFilterTicketDashBoard", {
        PageNumber: 1,
        PageSize: 10,
        PropId: globalProperty,
        Id: selectedCategory.Id,
        WardenId: selectedWarden?.Id || 1,
        ServiceProvId: 1,
        SearchText: overrideStatus,
        SearchFrom: fromDate,
        SearchTo: toDate,
        Flag: "TicketDash",
      });

      const { data: { Status, Data }, } = response;

      if (Status === 0 && Array.isArray(Data)) {
        setRows(Data);
        if (Data.length > 0) {
          setSelectedTicket(Data[0]);
          setSelectedRowCategoryId(Data[0].TktCategoryId);
        } else {
          setSelectedTicket(null);
          setSelectedRowCategoryId(null);
        }
      } else {
        setRows([]);
        setSelectedTicket(null);
        setSelectedRowCategoryId(null);
      }
    } catch (error) {
      setRows([]);
      setSelectedTicket(null);
      setSelectedRowCategoryId(null);
      toast.error("Error fetching tickets. Please try again.");
    }
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue ?? null);
    setSelectedRows([]);
    setSelectedCategoryId(null);
  };

  const handleWardenChange = (event, newValue) => {
    setSelectedWarden(newValue ?? null);
    setSelectedRows([]);
    setSelectedCategoryId(null);
  };

  const handleStatusClick = (status) => {
    return (event) => {
      event.preventDefault();
      setSelectedStatus(status);
      setSelectedRows([]);
      setSelectedCategoryId(null);
      fetchTickets(status);
    };
  };

  const handleRowClick = (row) => {
    setSelectedTicket(row);
    setSelectedRowCategoryId(row.TktCategoryId);
    setDialogOpen(true);
  };

  const handleMultiDialogClose = () => {
    setMultiDialogOpen(false);
  };

  const handleUpdate = () => {
    if (selectedRows.length === 1) {
      const selectedTicket = rows.find((row) => row.TicketId === selectedRows[0]);
      setSelectedTicket(selectedTicket);
      setSelectedRowCategoryId(selectedTicket.TktCategoryId);
      setDialogOpen(true);
    } else {
      setMultiDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogSubmit = async (ticketId, status, remark, resTktImg, resImgName, material, totalCost) => {
    const updatedBy = UserId;

    let ticketStatusCode = "";
    switch (status) {
      case "resolved":
        ticketStatusCode = "R";
        break;
      case "closed":
        ticketStatusCode = "C";
        break;
      case "hold":
        ticketStatusCode = "H";
        break;
      case "inprogress":
        ticketStatusCode = "I";
        break;
      case "open":
        ticketStatusCode = "O";
        break;
      default:
        toast.error("Invalid status selected");
        return;
    }

    try {
      const payload = {
        TicketId: ticketId,
        TicketSt: ticketStatusCode,
        Remark: remark || "",
        ConsMat: material || "",
        TotalCost: totalCost ? Number(totalCost) : 0,
        UpdatedBy: updatedBy,
        ResRemark: remark || "",
      };

      if (resTktImg) {
        payload.ResTktImg = resTktImg;
        payload.ResImgName = resImgName;
      } else {
        payload.ResTktImg = "";
        payload.ResImgName = "";
      }

      const updateStatusResponse = await axiosInstance.post(
        "TrnTicketing/UpdateTrnTicket",
        payload
      );

      const { data: { Status, Message } } = updateStatusResponse;
      if (Status === 0 && Message) {
        toast.success(Message, { autoClose: 1000 });
      }

      setSelectedTicket(null);
      setDialogOpen(false);
      fetchTickets();
      fetchCardData();
    } catch (error) {
      toast.error("Error during submission. Please try again.", { autoClose: 1000 });
    }
  };

  const handleGetData = () => {
    if (!globalProperty) {
      toast.error("Property is not set.", {
        autoClose: 1000,
      });
      return;
    }

    if (!selectedCategory || typeof selectedCategory !== "object" || !selectedCategory.Id) {
      toast.warn("Please select a category.", {
        position: "top-center",
        autoClose: 1500,
      });
      return;
    }

    setSelectedStatus("");
    fetchTickets("");
    fetchCardData();
  };

  const handleCancel = () => {
    setSelectedRows([]);
    setSelectedCategoryId(null);
  };

  const getStatusChip = (status, theme) => {
    let color, icon, bgColor;
    switch (status) {
      case "O":
        color = "error";
        icon = <PriorityHighIcon fontSize="small" />;
        bgColor = theme.palette.error.main;
        break;
      case "I":
        color = "warning";
        icon = <AutorenewIcon fontSize="small" />;
        bgColor = theme.palette.warning.main;
        break;
      case "H":
        color = "default";
        icon = <PauseIcon fontSize="small" />;
        bgColor = "#9c27b0";
        break;
      case "R":
        color = "default";
        icon = <DoneAllIcon fontSize="small" />;
        bgColor = "#FF5722";
        break;
      case "C":
        color = "success";
        icon = <CancelIcon fontSize="small" />;
        bgColor = theme.palette.success.main;
        break;
      default:
        color = "default";
        icon = null;
        bgColor = theme.palette.grey[200];
    }
    return (
      <Chip
        icon={icon}
        label={getStatusText(status)}
        color={color}
        size="small"
        sx={{
          fontWeight: 600,
          borderRadius: "12px",
          backgroundColor: bgColor,
          color: theme.palette.getContrastText(bgColor),
          "& .MuiChip-icon": {
            color: theme.palette.getContrastText(bgColor),
            fontSize: { xs: "0.9rem", sm: "0.5", md: "0.8rem" },
          },
          maxWidth: { xs: "110px", sm: "80px", md: "110px" },
          fontSize: { xs: "0.9rem", sm: "0.75rem" },
          padding: { xs: "2px 4px", sm: "4px 0px" },
        }}
      />
    );
  };

  const cardData = [
    { icon: <PriorityHighIcon />, label: "Open", value: ticketCounts.open, status: "O" },
    { icon: <AutorenewIcon />, label: "In Progress", value: ticketCounts.inprogress, status: "I" },
    { icon: <PauseIcon />, label: "Hold", value: ticketCounts.hold, status: "H" },
    { icon: <DoneAllIcon />, label: "Resolved", value: ticketCounts.resolved, status: "R" },
    { icon: <CancelIcon />, label: "Closed", value: ticketCounts.closed, status: "C" },
    { icon: <EqualizerIcon />, label: "Total Tickets", value: ticketCounts.totaltickets, status: "" },
  ];

  const fetchFollowHistory = async (ticketId) => {
    if (!ticketId) return;

    try {
      const response = await axiosInstance.post('TrnTktFlw/RetriveTrnTktFlw', {
        Flag: "Tkt",
        FlwId: 1,
        TicketId: ticketId,
      });

      if (response.data?.Status === 0) {
        setFollowHistory(response.data.Data || []);
      } else {
        setFollowHistory([]);
      }
    } catch (err) {
      toast.error("Failed to load follow-up history");
      setFollowHistory([]);
    }
  };

  return (
    <Grid container spacing={0}>
      <ToastContainer />
      <Grid item xs={12}
        sx={{
          overflowY: { xs: "auto", sm: "auto", md: "hidden" },
          overflowX: { xs: "hidden", sm: "hidden", md: "hidden" },
          pt: { xs: 0, sx: 1, md: 0 },
          pb: { xs: 2, sx: 1, md: 1 },
        }}
      >
        <Grid container
          sx={{
            px: { xs: 2, sm: 2, md: 4 },
            py: { xs: 1, sm: 0, md: 0 },
            bgcolor: theme.palette.background.default,
            minHeight: "85vh",
          }}
        >
          <Grid container spacing={1} alignItems="center" sx={{ marginBlock: 0.5 }}>
            <Grid item xs={12} sm={2} md={3}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  cursor: "pointer",
                  width: "100%",
                  gap: { xs: 1, sm: 1, md: 2 },
                  marginBottom: { xs: "5px", sm: "40px", md: "0px" },
                }}
              >
                <Tooltip title="Go Back" arrow onClick={() => navigate("/service&ticket/complaint")}>
                  <Avatar
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      width: { xs: 30, sm: 40, md: 40 },
                      height: { xs: 30, sm: 40, md: 40 },
                      boxShadow: theme.shadows[4],
                      cursor: "pointer",
                    }}
                  >
                    <KeyboardBackspaceIcon
                      sx={{
                        fontSize: { xs: 20, sm: 24, md: 28 },
                        color: "#fff",
                      }}
                    />
                  </Avatar>
                </Tooltip>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    letterSpacing: "-0.5px",
                    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Task Status
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={10} md={9}>
              <Grid container spacing={1} alignItems="center" justifyContent={{ xs: "flex-start", sm: "flex-start", md: "flex-end" }}>
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    label="From Date"
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        fontSize: { xs: "0.97rem", sm: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: { xs: "0.97rem", sm: "0.875rem" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    label="To Date"
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        fontSize: { xs: "0.97rem", sm: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: { xs: "0.97rem", sm: "0.875rem" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={2.5}>
                  <Autocomplete
                    key={warden.length}
                    options={warden}
                    getOptionLabel={(option) => option.Name || ""}
                    value={selectedWarden}
                    onChange={handleWardenChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="RaisedBy"
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder={warden.length === 0 ? "No wardens available" : "Select a warden"}
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: { xs: "0.99rem", sm: "0.875rem" },
                            height: { xs: "40px", sm: "36px" },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: { xs: "0.99rem", sm: "0.875rem" },
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                    noOptionsText="No wardens available"
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={5}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Autocomplete
                      key={categories.length}
                      options={categories}
                      getOptionLabel={(option) => option.Name || ""}
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Category"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder={categories.length === 0 ? "No categories available" : "Select a category"}
                          sx={{
                            "& .MuiInputBase-root": {
                              fontSize: { xs: "0.99rem", sm: "0.875rem" },
                              height: { xs: "40px", sm: "36px" },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: { xs: "0.99rem", sm: "0.875rem" },
                            },
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                      noOptionsText="No categories available"
                      sx={{ flex: 1 }}
                    />
                    <Box sx={{ display: { xs: "none", sm: "none", md: "flex" }, gap: 1 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleGetData}
                        sx={{
                          borderRadius: "4px",
                          textTransform: "none",
                          fontWeight: "bold",
                          px: { xs: 1, sm: 2 },
                          fontSize: { xs: "0.87rem", sm: "0.75rem", md: "0.875rem" },
                          height: { xs: "40px", sm: "36px" },
                          minWidth: { xs: "80px", sm: "80px", md: "80px" },
                        }}
                      >
                        Get Data
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleUpdate}
                        sx={{
                          borderRadius: "4px",
                          textTransform: "none",
                          fontWeight: "bold",
                          px: { xs: 1, sm: 2 },
                          fontSize: { xs: "0.87rem", sm: "0.75rem", md: "0.875rem" },
                          height: { xs: "40px", sm: "36px" },
                          minWidth: { xs: "100px", sm: "100px", md: "110px" },
                        }}
                      >
                        Bulk Update ({selectedRows.length})
                      </Button>
                    </Box>
                  </Box>
                </Grid>
                <Grid container item xs={12} sm={12} sx={{ display: { xs: "flex", md: "none" }, justifyContent: "center" }} spacing={1}>
                  <Grid item xs={12} sm={3} sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleGetData}
                      fullWidth
                      sx={{
                        borderRadius: "4px",
                        textTransform: "none",
                        fontWeight: "bold",
                        px: { xs: 1, sm: 2 },
                        fontSize: { xs: "1rem", sm: "0.75rem", md: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                        maxWidth: { xs: "200px", sm: "200px" },
                        margin: "0 auto",
                        flex: 1,
                      }}
                    >
                      Get Data
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleUpdate}
                      sx={{
                        borderRadius: "4px",
                        textTransform: "none",
                        fontWeight: "bold",
                        px: { xs: 1, sm: 2 },

                        height: "40px",
                        fontSize: "1rem",
                        flex: 1,
                        maxWidth: "200px",
                      }}
                    >
                      Bulk Update ({selectedRows.length})
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ mt: { xs: 0, sm: 2, md: 0 } }}>
              {cardData.map((card, index) => (
                <Grid item xs={12} sm={4} md={2} key={index}>
                  <StyledCard
                    onClick={handleStatusClick(card.status)}
                    sx={{
                      cursor: "pointer",
                      border: selectedStatus === card.status ? `2px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.divider}`,
                      width: "100%",
                    }}
                  >
                    <Grid container sx={{ display: "flex", alignItems: "center" }}>
                      <StyledAvatar status={card.status}>{card.icon}</StyledAvatar>
                      <Grid item sx={{ ml: 2.5 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontWeight: 500,
                            fontSize: { xs: "1rem", sm: "0.875rem" },
                          }}
                        >
                          {card.label}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            fontSize: { xs: "1rem", sm: "1rem" },
                          }}
                        >
                          {card.value || "0"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </StyledCard>
                </Grid>
              ))}
            </Grid>

            <TaskStatusTable
              rows={rows}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              selectedTicket={selectedTicket}
              handleUpdate={handleUpdate}
              getStatusChip={(status) => getStatusChip(status, theme)}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              handleCancel={handleCancel}
              selectedCategoryId={selectedCategoryId}
              setSelectedCategoryId={setSelectedCategoryId}
              handleRowClick={handleRowClick}
              onOpenHistory={(ticketId) => {
                setHistoryTicketId(ticketId);
                setHistoryDialogOpen(true);
                fetchFollowHistory(ticketId);
              }}
            />
            <TaskStDialog
              open={dialogOpen}
              onClose={handleDialogClose}
              ticket={selectedTicket}
              assignBy={assignBy}
              onSubmit={handleDialogSubmit}
              getStatusChip={(status) => getStatusChip(status, theme)}
              setSelectedRows={setSelectedRows}
              setSelectedCategoryId={setSelectedCategoryId}
            />
            <MultiStUpDlog
              open={multiDialogOpen}
              onClose={handleMultiDialogClose}
              tickets={rows.filter((row) => selectedRows.includes(row.TicketId))}
              propName={rows.find((row) => selectedRows.includes(row.TicketId))?.PropName}
              propId={globalProperty}
              setSelectedRows={setSelectedRows}
              setSelectedCategoryId={setSelectedCategoryId}
              fetchTickets={fetchTickets}
              fetchCardData={fetchCardData}
            />
            <FollowUpHistory
              open={historyDialogOpen}
              onClose={() => {
                setHistoryDialogOpen(false);
                setHistoryTicketId(null);
                setFollowHistory([]);
              }}
              history={followHistory}
              ticketId={historyTicketId}
              getStatusText={getStatusText}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}